export default {
  send: 'Send',
  typeMessage: 'Type message...',
};
